import List from '@/components/pages/InformationPortal/ProfilePage/Collections/List/List.vue'
import axios from 'axios'

export default {
    name: 'Collection',
    components: {List},
    data() {
        return {
            lists: {},
            listToDisplay: [],
            currentPage: 1,
            skip: 0,
            limit: 30,
            sort: 'created_at',
            order: 'desc',
            code: '',
        }
    },
    mounted() {
        this.checkQuery()
        this.addCSS()
    },
    methods: {
        checkQuery () {
            this.skip = this.$route.query.skip || 0
            this.limit = this.$route.query.skip || 30
            this.sort = this.$route.query.sort || 'created_at'
            this.order = this.$route.query.order || 'desc'
            this.code = this.$route.query.code
            if (this.$route && this.$route.query && this.$route.query.type && (this.$route.query.type === 'collection' || this.$route.query.type === 'dossier') && this.$route.query.code && this.$route.query.code !== '' && this.$route.query.action && this.$route.query.action === 'list' && this.$route.query.url && this.$route.query.url !== '') {  
                this.getList()
            }
        },
        /**
         * to add external css
         */
        addCSS () {
            var cssId = 'myCss';  // you could encode the css path itself to generate id..
            if (!document.getElementById(cssId) && this.$route && this.$route.query && this.$route.query.extCSS && this.$route.query.extCSS !== '')
            {
                var head  = document.getElementsByTagName('head')[0];
                var link  = document.createElement('link');
                link.id   = cssId;
                link.rel  = 'stylesheet';
                link.type = 'text/css';
                link.href = this.$route.query.extCSS;
                link.media = 'all';
                head.appendChild(link);
            }
        },
        getList () {
            let params = {
                skip: this.skip,
                limit: this.limit, 
                sort: this.sort,
                order: this.order,
                type: this.$route.query.type,
                code: this.$route.query.code,
                action: this.$route.query.action,
            }
            const encryptedText = this.CryptoJS.AES.encrypt(this.$route.query.url, process.env.VUE_APP_ENC_KEY).toString()
            let url = `${process.env.VUE_APP_API_BASE_URL}/tp/data`
            const options = {
                method: 'GET',
                params,
                url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'hM1qVepidQ330YvqjyluO3jLfGctW4s961PLzhpA',
                    'main-location': encryptedText
                }
            };
            
            let self = this
            axios(options).then(function (response) {
                if (response.data && response.data.items) {
                    self.lists = response || {}
                    self.listToDisplay = response.data.items || []
                }else{
                    throw new Error(response.data)
                }
            }).catch(function (error) {
                console.error('error', error)
            })
        },
        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // call for fetching the list
            this.getlist()
        }
    },
}